import { render, staticRenderFns } from "./DefaultUploadPlace.vue?vue&type=template&id=1c6099fc&"
import script from "./DefaultUploadPlace.vue?vue&type=script&lang=js&"
export * from "./DefaultUploadPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports